import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const CoffeeCard = ({ coffee, onAddToCart }) => {
  const [isAdding, setIsAdding] = useState(false);

  const handleAdd = () => {
    setIsAdding(true);
    // Simulate network request
    setTimeout(() => {
      onAddToCart(coffee);
      setIsAdding(false);
    }, 600);
  };

  return (
    <motion.div 
      whileHover={{ y: -8 }}
      className="group relative flex flex-col h-full focus-within:ring-4 focus-within:ring-moss/20 rounded-sm"
    >
      <div className="relative aspect-[3/4] overflow-hidden bg-cream-dark mb-6">
        <img 
          src={coffee.image} 
          alt={`Bag of ${coffee.name} coffee`} 
          className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
        />
        
        <div className="absolute top-4 left-4 z-10 flex flex-col gap-2">
          <div className="bg-espresso text-cream text-[10px] font-bold uppercase tracking-widest px-3 py-1.5 shadow-lg">
            {coffee.roast} Roast
          </div>
          <div className="bg-moss text-cream text-[10px] font-bold uppercase tracking-widest px-3 py-1.5 shadow-lg">
            {coffee.process}
          </div>
        </div>

        <div className="absolute inset-0 bg-espresso/40 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center pointer-events-none group-hover:pointer-events-auto">
          <button 
            onClick={handleAdd}
            disabled={isAdding}
            aria-label={`Quick add ${coffee.name} to cart`}
            className="bg-cream text-espresso px-6 py-3 font-bold uppercase tracking-widest text-[10px] hover:bg-moss hover:text-cream transition-all shadow-2xl cursor-pointer disabled:opacity-80 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-4 focus-visible:ring-moss"
          >
            {isAdding ? (
              <span className="flex items-center gap-2">
                <SafeIcon name="Loader" className="animate-spin" /> Adding...
              </span>
            ) : (
              'Quick Add +'
            )}
          </button>
        </div>
      </div>

      <div className="flex-1 flex flex-col">
        <div className="flex justify-between items-baseline mb-2">
          <span className="text-[10px] font-bold uppercase tracking-widest text-moss">{coffee.origin}</span>
          <div className="flex items-center gap-1 text-[11px] font-medium text-gray-500" aria-label={`Rated ${coffee.rating} out of 5 stars`}>
            <SafeIcon name="Star" className="text-amber-500 fill-amber-500" />
            <span aria-hidden="true">{coffee.rating}</span>
          </div>
        </div>
        
        <h3 className="font-serif text-2xl font-bold text-espresso mb-1 group-hover:text-moss transition-colors">{coffee.name}</h3>
        <p className="font-handwriting text-xl text-gray-500 mb-4">{coffee.region}</p>
        
        <div className="mt-auto pt-6 border-t border-gray-100 flex justify-between items-center">
          <span className="font-serif text-2xl font-bold">${coffee.price.toFixed(2)}</span>
          <div className="flex gap-1 flex-wrap justify-end">
            {coffee.notes.slice(0, 2).map(note => (
              <span key={note} className="text-[9px] uppercase tracking-tighter text-gray-400 border border-gray-200 px-2 py-0.5 rounded-full">
                {note}
              </span>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CoffeeCard;